/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateMemberRolesForm,
  UpdateMemberRolesForm$Outbound,
  UpdateMemberRolesForm$outboundSchema,
} from "../components/updatememberrolesform.js";

export type UpdateMemberRolesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateMemberRolesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateMemberRolesForm: UpdateMemberRolesForm;
};

/** @internal */
export type UpdateMemberRolesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateMemberRolesSecurity$outboundSchema: z.ZodMiniType<
  UpdateMemberRolesSecurity$Outbound,
  UpdateMemberRolesSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateMemberRolesSecurityToJSON(
  updateMemberRolesSecurity: UpdateMemberRolesSecurity,
): string {
  return JSON.stringify(
    UpdateMemberRolesSecurity$outboundSchema.parse(updateMemberRolesSecurity),
  );
}

/** @internal */
export type UpdateMemberRolesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  UpdateMemberRolesForm: UpdateMemberRolesForm$Outbound;
};

/** @internal */
export const UpdateMemberRolesRequest$outboundSchema: z.ZodMiniType<
  UpdateMemberRolesRequest$Outbound,
  UpdateMemberRolesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    updateMemberRolesForm: UpdateMemberRolesForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      updateMemberRolesForm: "UpdateMemberRolesForm",
    });
  }),
);

export function updateMemberRolesRequestToJSON(
  updateMemberRolesRequest: UpdateMemberRolesRequest,
): string {
  return JSON.stringify(
    UpdateMemberRolesRequest$outboundSchema.parse(updateMemberRolesRequest),
  );
}
